import Catchphraser from "../components/Catchphraser"
import CatchphraserPresentation from "../components/CatchphraserPresentation"
import CatchphraserComminity from "../components/CatchphraserCommunity"
const Presentation = ()=>{
    return(
    <CatchphraserComminity/>)
}
export default Presentation